import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AssetPoPreference } from '~/models/administration/AssetPoPreference';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class AssetPoPreferencesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminAssets);
    }
    
    getAssetPOPreference() {
        return this.http.get<AssetPoPreference>(this._url());
    }

    createOrUpdateAssetPOPreference(model: any) {
        return this.client.put(this._url(), model);
    }


    
    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/AssetPoPreferences${v}`);
    }

}